import React from "react";
import { Link } from "react-router-dom";
import { useI18n, pickLocalized } from "@/lib/i18n";

export default function BrandCard({ brand }) {
  const { t, locale } = useI18n();
  const desc = pickLocalized(brand.short_description, locale);
  const published = brand.profile?.published_count ?? 0;
  return (
    <Link
      to={`/brands/${brand.slug}`}
      className="block p-6 bg-white border transition-colors hover:border-black"
      style={{ borderColor: "var(--bp-border)" }}
      data-testid={`brand-card-${brand.slug}`}
    >
      <div className="flex items-center justify-between mb-2 text-xs font-mono uppercase tracking-widest" style={{ color: "var(--bp-text-muted)" }}>
        <span>{brand.sector_code}</span>
        <span>{brand.country}</span>
      </div>
      <h3 className="font-serif text-2xl leading-tight mb-2" style={{ color: "var(--bp-text)" }}>{brand.display_name}</h3>
      <p className="text-sm leading-relaxed line-clamp-3" style={{ color: "var(--bp-text-secondary)" }}>{desc}</p>
      <div className="mt-4 pt-4 border-t text-xs font-mono" style={{ borderColor: "var(--bp-border)", color: "var(--bp-text-muted)" }}>
        {t.publishes_of_seven(published)}
      </div>
    </Link>
  );
}
